import { LeagueName, LeagueType } from "../ranking/league.component";

interface LeagueIconProps {
  leagueType: LeagueType,
  size?: number
}

const LeagueIcon: React.FC<LeagueIconProps> = ({leagueType, size=40}) => {

  const league = LeagueName[leagueType];
  const h = "h-" + size;

  return (
    <img className={h} src={`${process.env.REACT_APP_STATIC_ASSETS}/images/${league}-step.png`}/>
  );
}

export default LeagueIcon;